<template>
    <section>
        <a href="#" class="site-logo mx-0 mx-md-auto" role="button">
            <span class="visually-hidden">Homepage</span>
        </a>
        <ul class="list-unstyled text-center pt-4">
            <li class="text-primary">Primary color</li>
            <li class="text-primary-alt">Primary (alt) color</li>
            <li class="text-secondary">Secondary color</li>
            <li class="text-success">Success color</li>
            <li class="text-info">Info color</li>
            <li class="text-warning">Warning color</li>
            <li class="text-danger">Danger color</li>
            <li class="text-dark">Dark color</li>
            <li class="text-light">Light color</li>
            <li class="text-white">White color</li>
            <li class="text-light-grey">Light grey color</li>
            <li class="text-light-blue">Light blue color</li>
            <li class="text-grayish-blue">Grayish blue color</li>
            <li class="text-light-grayish-blue">Light grayish blue color</li>
            <li class="text-soft-blue">Soft blue color</li>
        </ul>
    </section>
</template>

<script>
    export default {
        name: 'Branding'
    }
</script>
